export const DoctorStrangeInTheMultiverseOfMadness = () => {
    let datas = require.context('../../assets/images/origins/doctor-strange-in-the-multiverse-of-madness', false);
    return datas.keys().map(image => datas(image));
}